/**
 * Aspect Admin — Notifications / activity center.
 */

import { icon } from "./icons.js";
import { renderShell, pageHead, toast, emptyState } from "./shell.js";
import { escapeHtml } from "./auth_shell.js";
import { getSession } from "../auth_store.js";
import { navigate } from "../router.js";
import { t } from "../i18n.js";
import { NOTIFICATIONS } from "../mock_data.js";

let state = { filter: "all", read: new Set() };

const FILTERS = [
  ["all", "All"],
  ["ai", "AI & jobs"],
  ["team", "Team"],
  ["billing", "Billing"],
  ["security", "Security"],
];

const CATEGORY = {
  n1: "ai",
  n2: "ai",
  n3: "team",
  n4: "billing",
  n5: "ai",
  n6: "security",
};

export function renderActivity(root) {
  const session = getSession();
  if (!session) { navigate("/login", true); return; }

  const list = NOTIFICATIONS.filter((n) => state.filter === "all" || CATEGORY[n.id] === state.filter);
  const groups = [...new Set(list.map((n) => n.group))];
  const unreadCount = NOTIFICATIONS.filter((n) => n.unread && !state.read.has(n.id)).length;

  const content = `
    ${pageHead(t("Activity"), t("{n} unread notifications across the workspace.", { n: unreadCount }), `
      <button type="button" class="ap-btn" id="ac-prefs">${icon("sliders", 15)} ${t("Notification settings")}</button>
      <button type="button" class="ap-btn ap-btn--soft" id="ac-readall">${icon("check", 15)} ${t("Mark all read")}</button>
    `)}

    <div class="ap-toolbar">
      <div class="ap-chiprow">
        ${FILTERS.map(([id, label]) => `<button type="button" class="ap-chip ${state.filter === id ? "ap-chip--on" : ""}" data-filter="${id}">${t(label)}</button>`).join("")}
      </div>
    </div>

    ${
      !list.length
        ? `<div class="ap-panel">${emptyState({ icon: "bell", title: "All clear", body: "No notifications in this category. New events will show up here in real time." })}</div>`
        : groups
            .map(
              (g) => `
        <div class="ap-nav__section" style="margin:1.2rem 0.25rem 0.55rem;">${t(g)}</div>
        <div class="ap-panel">
          <div class="ap-feed">
            ${list
              .filter((n) => n.group === g)
              .map((n) => {
                const isUnread = n.unread && !state.read.has(n.id);
                return `
                <div class="ap-feed__item" data-notif="${n.id}" style="cursor:pointer;${isUnread ? "" : "opacity:0.72;"}">
                  <div class="ap-feed__icon ${n.kind ? `ap-feed__icon--${n.kind}` : ""}">${icon(n.icon, 15)}</div>
                  <div class="ap-feed__body">
                    <strong>${escapeHtml(t(n.title))}</strong>
                    ${isUnread ? `<span class="ap-dot" style="display:inline-block;background:var(--ap-cyan-bright);margin-left:0.45rem;box-shadow:0 0 6px var(--ap-cyan-glow);"></span>` : ""}
                    <br />${escapeHtml(t(n.body))}
                  </div>
                  <div class="ap-feed__time">${t(n.time)}</div>
                </div>`;
              })
              .join("")}
          </div>
        </div>`
            )
            .join("")
    }
  `;

  const el = renderShell(root, "/activity", content);
  if (!el) return;

  el.querySelectorAll("[data-filter]").forEach((c) =>
    c.addEventListener("click", () => {
      state = { ...state, filter: c.dataset.filter };
      renderActivity(root);
    })
  );

  el.querySelector("#ac-readall")?.addEventListener("click", () => {
    NOTIFICATIONS.forEach((n) => state.read.add(n.id));
    renderActivity(root);
    toast(root, t("All notifications marked read"), "ok");
  });

  el.querySelector("#ac-prefs")?.addEventListener("click", () => navigate("/settings"));

  el.querySelectorAll("[data-notif]").forEach((item) =>
    item.addEventListener("click", () => {
      state.read.add(item.dataset.notif);
      renderActivity(root);
    })
  );
}
